import React from 'react';
import {connect} from "react-redux";
import Select from "react-select";
import * as utils from "../../../utils/vessel";
import VesselForm from "../VesselForm";
import {Button} from "react-materialize";
import * as creationActions from "../../../actions/creation";

class SelectVessels extends React.Component {
    constructor(props) {
        super(props);
        this.state = {...props.formData};
    }

    onChange(value) {
        this.props.onChange(value);
    }


    render() {
        return (
            <div className="form-group field">
                <Button type="button" floating onClick={() => this.props.schema.openDrawer(VesselForm, null, creationActions.destroyingnewlyCreatedVessel())} icon="add" className="add-button btn-md ml5"/>
                <label className="control-label" htmlFor="root_vessel">
                    Vessel
                </label>

                <Select
                    backspaceRemoves={false}
                    className="form-control"
                    name="root_vessel"
                    value={this.props.formData}
                    options={utils.vesselToSelect(this.props.vessels)}
                    isLoading={this.props.loading}
                    clearable={false}
                    onChange={this.onChange.bind(this)}
                    simpleValue
                    valueComponent={(props) => {
                        return (
                            <div className="Select-value" title={props.value.title}>
                                <span className="Select-value-label">
                                    {props.children}
                                    <div className="pull-right mr25 input-button-wrapper">
                                        <i>
                                            <Button type="button" floating onClick={() => this.props.schema.openDrawer(VesselForm, {item: props.value.item}, creationActions.destroyingnewlyCreatedVessel())} icon="edit" className="edit-button small"/>
                                        </i>
                                    </div>
                                </span>
                            </div>
                        )
                    }}
                />
            </div>
        )
    }
}

export default connect((state) => {
    return Object.assign({}, {
        vessels: state.vessel.vessels,
        loading: state.vessel.loading
    });
})(SelectVessels);


// WEBPACK FOOTER //
// ./src/components/forms/fields/SelectVessels.js